import React from "react";
import createReactClass from "create-react-class";

export default createReactClass({
  displayName: "Root",
  getInitialState() {
    return {};
  },
  componentDidMount() {
    $(".btn-thanks-comment").on("click", function() {
      $(".btn-thanks-comment").hide();
      $(".thanks-comment-form").show();
    });
  },
  sendCommentToServer() {
    $.ajax({
      url: "/api/thank/send_thank_comment",
      type: "post",
      cache: false,
      data: {
        user_id: this.props.selectedUserId,
        event_id: this.props.eventId,
        circle_id: this.props.circleId,
        comment: this.commentForm.value,
      },
      success: function() {}.bind(this),
      error: function() {}.bind(this),
    });
  },
  handleCommentSendButton() {
    this.sendCommentToServer();
  },
  render() {
    // if (this.props.isSendingThanks) {
    //   return <div className="modal fade" id="thanks-comment-btn" tabIndex="-1" role="dialog" aria-labelledby="loginLabel" aria-hidden="true">
    //     <div className="modal-dialog">
    //       <div className="modal-content">
    //         <div className="modal-header" style={{borderBottom: "none"}}>
    //         </div>
    //         <div className="modal-body">
    //           <Loader isActive={true} />
    //         </div>
    //         <div className="modal-footer">
    //         </div>
    //       </div>
    //     </div>
    //   </div>;
    // }
    return (
      <div
        className="modal fade"
        id="thanks-comment-btn"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="loginLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header" style={{ borderBottom: "none" }}>
              <button type="button" className="close" data-dismiss="modal">
                <span aria-hidden="true">×</span>
                <span className="sr-only">Close</span>
              </button>
              <h4 className="modal-title" id="loginLabel">
                「ありがとう！」を贈りました。
              </h4>
            </div>
            <div className="modal-body">
              <div className="thanks-comment-form">
                <textarea
                  className="form-control thanks-textarea"
                  ref={(c) => {
                    this.commentForm = c;
                  }}
                />
                <button
                  className="btn u-btn-pink btn-md"
                  style={{ width: "100%", margin: "10px 0 5px" }}
                  data-dismiss="modal"
                  onClick={this.handleCommentSendButton}
                >
                  <i className="fas fa-rocket" /> 送信
                </button>
              </div>
              <button
                className="btn u-btn-pink btn-md btn-thanks-comment"
                style={{ width: "100%", margin: "10px 0 5px" }}
                onClick={this.commentFormOpenButtonHandle}
              >
                <i className="fas fa-rocket" /> コメントも送る
              </button>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                data-dismiss="modal"
                className="close btn btn-xs btn-default"
                style={{ fontSize: "14px", color: "#333333" }}
              >
                &nbsp;閉じる&nbsp;
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  },
});
